import { render } from "./searchCollegestudents.vue?vue&type=template&id=0f7b454d&scoped=true"
import script from "./searchCollegestudents.vue?vue&type=script&lang=js"
export * from "./searchCollegestudents.vue?vue&type=script&lang=js"

import "./searchCollegestudents.vue?vue&type=style&index=0&id=0f7b454d&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/2026_cdf/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7b454d"]])

export default __exports__